const getters = {
    feedbackId: (state) =>state.feedbackId,
    loading: state => state.loading,
};

export default getters;